import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  FiCopy,
  handleCopy,
} from "@/components/common/commonFunction/handleCopy";

function SquareAndSquareroot() {
  const [changeupSuare, setChangeupSuare] = useState("");
  const [text, setText] = useState("");
  const [copy, setCopy] = useState(false);
  const [placeData, setPlaceData] = useState({
    input: "Ex. 12",
    output: "144",
  });
  const [errors, setErrors] = useState(null);

  const handleOnChange = (event) => {
    if (event.target.value !== "") {
      setPlaceData({});
    } else {
      setPlaceData({ input: "Ex. 12", output: "144" });
    }
    setCopy(false);
    setText(event.target.value);
    setErrors("");

    setChangeupSuare("");
  };

  const handleWhiteSpace = () => {
    if (validateForm()) {
      let e = document.getElementById("WhiteSpace");
      let value = e.value;

      if (value == "Square Root") {
        if (text < 0) {
          toast.error("Enter Positive value");
        } else {
          setChangeupSuare(Math.sqrt(text));
        }
      } else {
        setChangeupSuare(text * text);
      }
      setCopy(false);
    }
  };

  const validateForm = () => {
    let formIsValid = true;

    if (!text) {
      setErrors("* Please enter number");

      formIsValid = false;
    }

    return formIsValid;
  };
  return (
    <>
      <div className="commom-box-new">
        <div className="input-new">
          <input
            type="number"
            placeholder={placeData?.input}
            onChange={handleOnChange}
            className={errors && "error-input"}
          ></input>
          <span className="text-sm text-red-700">{errors}</span>
        </div>
      </div>

      <div className="commom-box-new truncate-text-top-alignment">
        <div className="input-new">
          <select id="WhiteSpace">
            <option value="Square">Square</option>
            <option value="Square Root">Square Root</option>
          </select>
        </div>
      </div>
      <div className="button lowercase-center-alignment">
        <button onClick={handleWhiteSpace}>Convert</button>
      </div>
      {changeupSuare && (
        <div className="commom-box-new">
          <div className="copy-textarea-icon-alignment">
            <FiCopy onClick={() => handleCopy(changeupSuare)} />
            {copy && (
              <div>
                <span>Copied</span>
              </div>
            )}
          </div>
          <div className="input-new">
            <input
              type="number"
              value={changeupSuare}
              placeholder={placeData?.output}
              disabled
              className="text-black"
            ></input>
          </div>
        </div>
      )}
    </>
  );
}

export default SquareAndSquareroot;
